/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateScheduleRequest } from '../models/CreateScheduleRequest';
import type { EmployeeSchedules } from '../models/EmployeeSchedules';
import type { ListEmployeeWithHourSchedule } from '../models/ListEmployeeWithHourSchedule';
import type { PPDRow } from '../models/PPDRow';
import type { Schedule } from '../models/Schedule';
import type { ScheduleCallOff } from '../models/ScheduleCallOff';
import type { ScheduleChartData } from '../models/ScheduleChartData';
import type { ScheduleDailyReport } from '../models/ScheduleDailyReport';
import type { ScheduleSetting } from '../models/ScheduleSetting';
import type { SendScheduleSMSResponse } from '../models/SendScheduleSMSResponse';
import type { SettingsPayload } from '../models/SettingsPayload';
import type { ShiftBid } from '../models/ShiftBid';
import type { ShiftBidWithSchedule } from '../models/ShiftBidWithSchedule';
import { request as __request } from '../core/request';

export class ScheduleService {

    /**
     * create schedule
     * @returns Schedule Create schedule
     * @throws ApiError
     */
    public static async createSchedule({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: CreateScheduleRequest,
}): Promise<Array<Schedule>> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/schedule`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * get schedule list
     * @returns Schedule fetch schedule list
     * @throws ApiError
     */
    public static async getScheduleList({
companyId,
status,
start,
end,
assignee,
department,
titleId,
shiftId,
}: {
/** The companyId **/
companyId: number,
/** The submissionId **/
status?: string,
/** Start date (YYYY-MM-DD or RFC3339) **/
start?: string,
/** End date (YYYY-MM-DD or RFC3339) **/
end?: string,
/** assignee **/
assignee?: number,
/** department id **/
department?: number,
/** department title id **/
titleId?: number,
/** shift id **/
shiftId?: number,
}): Promise<Array<Schedule>> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/schedule`,
            query: {
                'status': status,
                'start': start,
                'end': end,
                'assignee': assignee,
                'department': department,
                'titleId': titleId,
                'shiftId': shiftId,
            },
        });
        return result.body;
    }

    /**
     * get schedule list
     * @returns PPDRow fetch schedule list
     * @throws ApiError
     */
    public static async getSchedulePpdList({
companyId,
start,
end,
department,
titleId,
shiftId,
}: {
/** The companyId **/
companyId: number,
/** Start date (YYYY-MM-DD or RFC3339) **/
start?: string,
/** End date (YYYY-MM-DD or RFC3339) **/
end?: string,
/** department id **/
department?: number,
/** department title id **/
titleId?: number,
/** shift id **/
shiftId?: number,
}): Promise<Array<PPDRow>> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/schedule/ppd`,
            query: {
                'start': start,
                'end': end,
                'department': department,
                'titleId': titleId,
                'shiftId': shiftId,
            },
        });
        return result.body;
    }

    /**
     * send schedule sms
     * @returns SendScheduleSMSResponse Create schedule
     * @throws ApiError
     */
    public static async sendScheduleSms({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: Array<EmployeeSchedules>,
}): Promise<SendScheduleSMSResponse> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/schedule/sms`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * update schedule
     * @returns Schedule Update Schedule
     * @throws ApiError
     */
    public static async updateSchedule({
companyId,
scheduleId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The schedule id **/
scheduleId: number,
requestBody: Schedule,
}): Promise<Schedule> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/schedule/${scheduleId}`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * get maintenance request detail
     * @returns Schedule Fetch schedule by id
     * @throws ApiError
     */
    public static async getScheduleById({
companyId,
scheduleId,
}: {
/** The companyId **/
companyId: number,
/** The schedule id **/
scheduleId: number,
}): Promise<Schedule> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/schedule/${scheduleId}`,
        });
        return result.body;
    }

    /**
     * delete schedule
     * @returns any Delete Schedule
     * @throws ApiError
     */
    public static async deleteSchedule({
companyId,
scheduleId,
}: {
/** The companyId **/
companyId: number,
/** The schedule id **/
scheduleId: number,
}): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/companies/${companyId}/schedule/${scheduleId}`,
        });
        return result.body;
    }

    /**
     * update schedule status
     * @returns Schedule Update Schedule Status
     * @throws ApiError
     */
    public static async updateScheduleStatus({
companyId,
scheduleId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The schedule id **/
scheduleId: number,
requestBody: Schedule,
}): Promise<Schedule> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/schedule/${scheduleId}/status`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * update schedule status
     * @returns any Update Schedule Status Called Off
     * @throws ApiError
     */
    public static async updateScheduleCallOff({
companyId,
scheduleId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The schedule id **/
scheduleId: number,
requestBody: ScheduleCallOff,
}): Promise<any> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/schedule/${scheduleId}/call-off`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * create shift bid
     * @returns ShiftBid Create Shift Bid
     * @throws ApiError
     */
    public static async createShiftBid({
companyId,
scheduleId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The schedule id **/
scheduleId: number,
requestBody: ShiftBid,
}): Promise<ShiftBid> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/schedule/${scheduleId}/bid`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * get list of shift bids
     * @returns ShiftBidWithSchedule Fetch shift bid
     * @throws ApiError
     */
    public static async getShiftBid({
companyId,
scheduleId,
}: {
/** The companyId **/
companyId: number,
/** The schedule id **/
scheduleId: number,
}): Promise<Array<ShiftBidWithSchedule>> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/schedule/${scheduleId}/bid`,
        });
        return result.body;
    }

    /**
     * update schedule status
     * @returns ShiftBid Update Shift Bid Status
     * @throws ApiError
     */
    public static async updateShiftBidStatus({
companyId,
scheduleId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The schedule id **/
scheduleId: number,
requestBody: ShiftBid,
}): Promise<ShiftBid> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/schedule/${scheduleId}/bid/status`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * Get all employees with total scheduled hours
     * @returns ListEmployeeWithHourSchedule Successfully retrieved schedule transfers
     * @throws ApiError
     */
    public static async listEmployeesWithScheduleHours({
companyId,
}: {
/** The companyId **/
companyId: number,
}): Promise<Array<ListEmployeeWithHourSchedule>> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/schedule/employees`,
        });
        return result.body;
    }

    /**
     * Get schedule chart data for an employee
     * Returns aggregated scheduled hours and transferred hours for a given requester within an optional date range.
 * 
     * @returns ScheduleChartData Schedule chart data retrieved successfully
     * @throws ApiError
     */
    public static async getScheduleChartData({
companyId,
start,
end,
}: {
/** ID of the company that owns the schedule data **/
companyId: number,
/** Start of the date range (inclusive). If omitted along with `end`, no date filtering is applied.
 *  **/
start?: string,
/** End of the date range (inclusive). If omitted along with `start`, no date filtering is applied.
 *  **/
end?: string,
}): Promise<ScheduleChartData> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/schedule/chart-data`,
            query: {
                'start': start,
                'end': end,
            },
            errors: {
                400: `Invalid query parameters (e.g. only one of start/end provided)`,
                401: `Unauthorized`,
                404: `Company or requester not found`,
                500: `Internal server error`,
            },
        });
        return result.body;
    }

    /**
     * Get daily schedule report
     * Returns aggregated schedule report (hours, census, PPD) by title for a given company and date, optionally filtered by department.
     * @returns ScheduleDailyReport Daily schedule report
     * @throws ApiError
     */
    public static async getScheduleService({
companyId,
date,
department,
}: {
companyId: number,
date: string,
department?: number,
}): Promise<ScheduleDailyReport> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/schedule/report`,
            query: {
                'date': date,
                'department': department,
            },
            errors: {
                400: `Invalid request parameters`,
                401: `Unauthorized`,
                500: `Internal server error`,
            },
        });
        return result.body;
    }

    /**
     * Get schedule settings
     * Retrieves the schedule settings for a specific company.
     * @returns ScheduleSetting Schedule settings retrieved successfully
     * @throws ApiError
     */
    public static async getScheduleSettings({
companyId,
}: {
/** Unique ID of the company **/
companyId: number,
}): Promise<ScheduleSetting> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/schedule/settings`,
        });
        return result.body;
    }

    /**
     * Create or update schedule settings
     * Upserts schedule settings for a specific company.
     * @returns ScheduleSetting Schedule settings updated successfully
     * @throws ApiError
     */
    public static async upsertScheduleSettings({
companyId,
requestBody,
}: {
/** Unique ID of the company **/
companyId: number,
requestBody: SettingsPayload,
}): Promise<ScheduleSetting> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/schedule/settings`,
            body: requestBody,
        });
        return result.body;
    }

}